import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getMoviesByCategory } from "@/utils/movie";

export default function CategoryLinks() {
  return (
    <section className="w-full px-4 md:px-6 pt-12 md:pt-16">
      <div className="flex items-end justify-between mb-5 md:mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">分类快捷入口</h2>
          <p className="mt-1 text-sm text-foreground-500">按题材与风格快速定位想看的三级影片</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5">
        {categories.map((category) => {
          const count = getMoviesByCategory(category.id).length;
          return (
            <Link
              key={category.id}
              to={`/category/${category.id}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200/70 bg-background-100 p-4 md:p-5 transition-colors hover:border-accent-500/70"
            >
              <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-lg bg-primary-500/15 text-primary-300 group-hover:bg-accent-500 group-hover:text-foreground-950 transition-colors">
                <i className={`${category.icon} text-2xl`} />
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-accent-500 transition-colors">
                    {category.name}
                  </h3>
                  <span className="rounded-full bg-secondary-500/20 px-2 py-0.5 text-xs text-secondary-300">
                    {count} 部
                  </span>
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-500 line-clamp-2">
                  {category.description}
                </p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}